import { AlpineComponent } from 'alpinejs';

import { alpineComponentNoStore } from '@/src/utilities/component-utilities';

const IDENTIFIER = 'conditionCategoryFilter';

export const conditionCategoryFilterComponent =
  alpineComponentNoStore<ConditionCategoryFilterComponent>(IDENTIFIER, factory);

function factory() {
  const state = window[IDENTIFIER];

  const conditions = (state.conditions ?? []).map((c) => ({
    nodeID: c.nodeID,
    title: c.title.toLowerCase(),
    terms: c.terms.map((t) => ({
      id: t.id,
      displayName: t.displayName.toLowerCase(),
    })),
  }));

  let textVal = '';

  return {
    get text() {
      return textVal;
    },
    set text(value) {
      textVal = value;

      this.filter(textVal);
    },
    conditions,
    filteredConditions: conditions,

    filter(text) {
      const lowerText = text.toLowerCase().trim();

      if (!lowerText) {
        this.filteredConditions = this.conditions;
      }

      this.filteredConditions = conditions.reduce((prev, c) => {
        const terms = c.terms.filter((t) => t.displayName.includes(lowerText));

        if (!c.title.includes(lowerText) && terms.length === 0) {
          return prev;
        }

        prev.push({
          nodeID: c.nodeID,
          title: c.title,
          terms,
        });

        return prev;
      }, [] as SiteComponents.ConditionCategoryCondition[]);
    },

    showCondition(nodeID) {
      return !!this.filteredConditions.find((c) => c.nodeID === nodeID);
    },

    showTooltip(nodeID) {
      if (!this.text) {
        return false;
      }

      const condition = this.filteredConditions.find(
        (c) => c.nodeID === nodeID
      );

      const lowerText = this.text.toLowerCase().trim();

      if (!condition || condition.title.includes(lowerText)) {
        return false;
      }

      return condition.terms.length > 0;
    },
  } as ConditionCategoryFilterComponent;
}

interface ConditionCategoryFilterComponent extends AlpineComponent {
  text: string;
  conditions: SiteComponents.ConditionCategoryCondition[];
  filteredConditions: SiteComponents.ConditionCategoryCondition[];

  filter(text: string): void;
  showCondition(nodeID: number): boolean;
  showTerm(nodeID: number, termID: number): boolean;
  showTooltip(nodeID: number): boolean;
}
